import React from 'react';
import './Footer.css';
import { FaDiscord } from 'react-icons/fa';
import XIcon from './XIcon';
import { Link } from 'react-router-dom';

const Footer = () => {
    // Custom event handlers for navigation
    const handleNavigateToHome = (e) => {
        e.preventDefault();
        window.dispatchEvent(new CustomEvent('navigateToHome'));
    };
    
    const handleNavigateToGallery = (e) => {
        e.preventDefault();
        window.dispatchEvent(new CustomEvent('navigateToGallery'));
    };
    
    const handleOpenAboutPopup = (e) => {
        e.preventDefault();
        window.dispatchEvent(new CustomEvent('openAboutPopup'));
    };
    return (
        <footer className="footer">
            <div className="footer-container">
                <div className="footer-section brand">
                    <h3>IMMUTA</h3>
                    <p>Exploring art through the digital canvas</p>
                </div>
                
                <div className="footer-section links">
                    <h3>Quick Links</h3>
                    <ul>
                        <li><Link to="/" onClick={handleNavigateToHome}>Home</Link></li>
                        <li><Link to="/" onClick={handleNavigateToGallery}>Gallery</Link></li>
                        <li><Link to="/" onClick={handleNavigateToGallery}>Artists</Link></li>
                        <li><Link to="/" onClick={handleOpenAboutPopup}>About</Link></li>
                    </ul>
                </div>
                
                <div className="footer-section social">
                    <h3>Connect</h3>
                    <div className="social-icons">
                        <a href="https://x.com/immuta_art" target="_blank" rel="noopener noreferrer" aria-label="X"><XIcon /></a>
                        <a href="https://discord.gg/wWrwKhJu54" target="_blank" rel="noopener noreferrer" aria-label="Discord"><FaDiscord /></a>
                    </div>
                </div>
            </div>
            
            <div className="footer-bottom">
                <p>&copy; {new Date().getFullYear()} Immuta. All rights reserved.</p>
                <p className="footer-attribution">A product of <a href="https://vivacarta.net" target="_blank" rel="noopener noreferrer">VIVA CARTA</a></p>
            </div>
        </footer>
    );
};

export default Footer;
